import React from 'react';

import { Stack } from '@mantine/core';

import EncounterList from '../components/encounter/EncounterList';

const AllEncounters: React.FC = () => {
  return (
    <Stack gap="lg">
      <EncounterList 
        title="All Encounters"
      />
    </Stack>
  );
};

export default AllEncounters;

